import { isBrowser, TokenCookiesKey } from "../constants/index"

export const setCookie = (key, val) => {
  if (isBrowser) {
    document.cookie = `${key}=${val};path=/`;
  }
}

export const deleteCookie = (key) => {
  if (isBrowser) {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
  }
}

export const getCookie = (key) => {
  if (isBrowser && document.cookie.includes(key)) {
    const cookieList = document.cookie.split(";")
    const result = cookieList.find(item => item.includes(key)).split(`${key}=`)[1]
    return result
  }
  return ""
}